import {gql} from "@irati/utils/gql"

const mutation = gql`
  mutation DeleteReaction($uuid: String!) {
    deleteReaction(uuid: $uuid)
  }
`

export default mutation
